// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ExportSvg from '@rsuite/icon-font/lib/network/Export';
var Export = createSvgIcon({
  as: ExportSvg,
  ariaLabel: 'export',
  category: 'network',
  displayName: 'Export'
});
export default Export;